module.exports = __webpack_public_path__ + "0e99222b18006a1c88ffa56943219994.svg";